import _ from "lodash";
import { ENTITY_TYPE } from "MyCalendar/modules/MyCalendarModule/MyCalendarConstants";

const useGetUserCountByEntity = ({
  participantSelections,
  selectedListType,
  sharedWith,
}) => {
  // Assumption: in production, each selected grade/class already includes its participants.
  // Otherwise, we would need per-selection API calls (previous approach), which hurts performance and UX.
  const heuristicCount = _.size(participantSelections?.[selectedListType]) || 0;

  // Format participants for CUSTOM entity type
  const customParticipants = participantSelections[ENTITY_TYPE.CUSTOM] || [];
  const formattedCustomParticipants = _.groupBy(
    customParticipants,
    "__typename"
  );
  const userByUserType = {
    [ENTITY_TYPE.STAFF]: formattedCustomParticipants["Staff"] || [],
    [ENTITY_TYPE.STUDENT]: formattedCustomParticipants["Student"] || [],
    [ENTITY_TYPE.PARENT]: formattedCustomParticipants["FamilyMember"] || [],
  };

  const userCountByEntityIncludingCustom =
    selectedListType === ENTITY_TYPE.CUSTOM
      ? {
          staffCount: _.size(_.get(userByUserType, ENTITY_TYPE.STAFF, [])),
          studentCount: _.size(_.get(userByUserType, ENTITY_TYPE.STUDENT, [])),
          familyCount: _.size(_.get(userByUserType, ENTITY_TYPE.PARENT, [])),
        }
      : {};

  const staffCount = _.includes(sharedWith, "STAFF")
    ? userCountByEntityIncludingCustom?.staffCount || 0
    : 0;
  const studentCount = _.includes(sharedWith, "STUDENT")
    ? userCountByEntityIncludingCustom?.studentCount || 0
    : 0;
  const familyCount = _.includes(sharedWith, "FAMILY_MEMBER")
    ? userCountByEntityIncludingCustom?.familyCount || 0
    : 0;

  const totalParticipants =
    staffCount + studentCount + familyCount || heuristicCount;

  return {
    totalParticipants,
  };
};

export default useGetUserCountByEntity;
